module.exports = __webpack_public_path__ + "static/img/TATE-HODGSON.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TATE-HODGSON.jpg
// module id = VK6z
// module chunks = 0